/**
 * Reusable AgeSelector component for landing page
 */

import { cn } from "../../lib/utils";
import { focusStyles, hoverStyles } from "../../utils/styles";
import { AgeRange } from "../../types/landing";
import { AGE_OPTIONS } from "../../constants/landing";

interface AgeSelectorProps {
  selectedAge: AgeRange | null;
  onAgeSelect: (age: AgeRange) => void;
  theme: {
    colors: {
      text: {
        title: string;
        primary: string;
      };
    };
  };
}

export function AgeSelector({ selectedAge, onAgeSelect, theme }: AgeSelectorProps) {
  return (
    <div className="mb-2 mx-auto px-4">
      <h3
        id="age-selector-title"
        className={cn("text-lg font-bold mb-2 text-center", theme.colors.text.title)}
      >
        Select Age Range
      </h3>
      <div
        className="grid grid-cols-1 sm:grid-cols-3 gap-3"
        role="radiogroup"
        aria-labelledby="age-selector-title"
      >
        {AGE_OPTIONS.map(option => (
          <button
            key={option.value}
            role="radio"
            aria-checked={selectedAge === option.value}
            aria-label={`Select age range ${option.label}`}
            className={cn(
              "min-h-[2.5rem] sm:min-h-[2.5rem] px-1 sm:px-2 py-3 rounded-lg border-2 font-bold text-base",
              "w-32 sm:w-auto", // Narrow width on mobile, auto on desktop
              selectedAge === option.value
                ? "border-brand-secondary bg-brand-secondary text-text-inverse"
                : "border-border-default bg-surface-alt text-text-primary hover:border-brand-secondary",
              focusStyles.ring,
              hoverStyles.scale
            )}
            onClick={() => onAgeSelect(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
